// extracted by mini-css-extract-plugin
module.exports = {"root":"RelativeTime-root-d30b4f3b231d2f240c2f63990321529f"};